import React from "react";
import Portfolio from "../../Portfolio";

const MediaCoverage = () => {
  const portfolioImage = [
    {
      img: "assets/img/m-media/transformed_edu.png",
      title: "Transformation lives through Education",
      link: "/media-coverage-view/transformation-lives-through-Education",
      description: " -Sudhamoy, Member of Mallabhum Prayas",
    },
    {
      img: "assets/img/m-media/jantaDocan.png",
      title: "Janta Dokan’ at Jangal Mahal",
      link: "/media-coverage-view/janta-Dokan-at-Jangal-Mahal",
      description: "-Subhasish, Member of Mallabhum Prayas",
    },
    {
      img: "assets/img/m-media/darkness.png",
      title: "A Glimpse light in the Darkness",
      link: "/media-coverage-view/glimpse-light-in-the-Darkness",
      description: "  -Kushal, Member of Mallabhum Prayas",
    },
    {
      img: "assets/img/m-media/festive-mode.png",
      title: "Extend ourselves beyond Festive mode",
      link: "/media-coverage-view/extend-ourselves-beyond-Festive-mode",
      description: "-Rohit, Member of Mallabhum Prayas ",
    },
  ];

  const samagDarpan = (
    <div
      style={{
        fontSize: "16px",
        lineHeight: "1.5",
        color: "#333",
        margin: "20px 0",
      }}
    >
      <p>
        Mallabhum Prayas Media coverage highlights the transformative impact of
        education on community lives, showcasing initiatives like 'Janta Dokan'
        in Jangal Mahal, The coverage emphasizes the organization's commitment
        to illuminating paths in challenging circumstances, offering a glimpse
        of hope and resilience in the darkness. By extending their efforts
        beyond festive celebrations, Mallabhum Prayas fosters a culture of
        continuous support and development, encouraging members to engage
        actively in societal upliftment. Through various platforms, they share
        inspiring stories of change, illustrating how education and community
        initiatives can create lasting positive effects, ultimately transforming
        lives and fostering a brighter future for all..
      </p>
    </div>
  );
  return (
    <Portfolio
      portfolioHeader="Media Coverage"
      description={samagDarpan}
      portfolioImage={portfolioImage}
      fullImage={false}
      moreDetails
    />
  );
};

export default MediaCoverage;
